import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import _isEmpty from "lodash/isEmpty"
import { validateField } from "@/utils/helper"
import {
  getJobTypeList,
  selectGenericState,
} from "@/store/features/genericSlice"
import Input from "@/components/core/Input/Input"
import Dropdown from "@/components/core/SelectDropdown/SelectDropdown"
import RadioButton from "@/components/core/RadioButton/RadioButton"

const BusinessInfo = props => {
  const { data, i18n, setData, error } = props
  const { jobTypePath } = useSelector(selectGenericState)
  const dispatch = useDispatch()
  const [jobTypes, setJobType] = useState([])
  const [subJobTypes, setSubJobTypes] = useState([])
  const radioKeyDown = e => {
    const nextRadio = e.target.nextSibling
    const previousRadio = e.target.previousSibling
    if (e.key === "ArrowLeft" && previousRadio) {
      previousRadio.focus()
    } else if (e.key === "ArrowRight" && nextRadio) {
      nextRadio.focus()
    } else if (e.key === "Enter" || e.key === " ") {
      e.preventDefault()
      e.target.click()
    }
  }

  useEffect(() => {
    try {
      if (!_isEmpty(jobTypePath)) getJobTypes()
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error)
    }
  }, [jobTypePath])

  const getJobTypes = async () => {
    const jobType = await dispatch(getJobTypeList())
    setJobType(jobType?.payload)
  }

  const selectJobType = jobType => {
    setData({ ...data, jobType, subJobType: "" })
    const subTypeL = jobTypes
      .find(el => el.text === jobType)
      .value.split(",")
      .filter(e => e)
    setSubJobTypes(subTypeL)
    props.setError({
      ...error,
      jobType: false,
    })
  }

  const selectSubJobType = subJobType => {
    setData({ ...data, subJobType })
    props.setError({
      ...error,
      subJobType: false,
    })
  }

  return (
    <div
      className="optional-form"
      role="radiogroup"
      aria-labelledby="with-professional-radio"
    >
      <fieldset>
        <legend>
          <h3 id="business-information-section" className="question">
            {i18n.businessInformation}
          </h3>
        </legend>
        <div className="business-form-wrapper">
          <Input
            id="kf-company-name"
            type="text"
            value={data?.company || ""}
            maxLength={50}
            placeholder={`${i18n.company}*`}
            label={`${i18n.company}*`}
            onChange={e => {
              const { value } = e.target
              if (validateField("company", value) || value === "") {
                setData({ ...data, company: value })
              }
            }}
            showError={error.company}
            errorMessage={error.company}
            onBlur={() => props.onBlur("company")}
          />
          <Input
            id="kf-company-website"
            type="text"
            value={data?.companyWebsite || ""}
            maxLength={50}
            placeholder={`${i18n.companyWebsite}*`}
            label={`${i18n.companyWebsite}*`}
            onChange={e => {
              const { value } = e.target
              if (validateField("companyWebsite", value) || value === "") {
                setData({ ...data, companyWebsite: value })
              }
            }}
            showError={error.companyWebsite}
            errorMessage={error.companyWebsite}
            onBlur={() => props.onBlur("companyWebsite")}
          />
          <div className="mobile-pl-0">
            <Dropdown
              id="contact-user-job-type"
              customClass="input-field"
              data={jobTypes?.map(el => el.text)}
              value={data?.jobType ?? ""}
              label={`${i18n.jobType}*`}
              onChange={selectJobType}
              showError={error.jobType}
              errorMessage={error.jobType}
              onBlur={() => props.onBlur("jobType")}
            />
          </div>
          {data.jobType && subJobTypes.length > 0 && (
            <div className="mobile-pl-0">
              <Dropdown
                id="contact-user-subJobType"
                data={subJobTypes}
                value={data.subJobType}
                label={`${i18n.typeOf}${data.jobType}*`}
                onChange={selectSubJobType}
                showError={error.subJobType}
                errorMessage={error.subJobType}
                onBlur={() => props.onBlur("subJobType")}
              />
            </div>
          )}
        </div>
        <div className="trade-customer-radio-option">
          <div className="radio-wrapper" role="radiogroup">
            <span className="trade-customer">{i18n.asTradeCustomer}</span>
            <RadioButton
              id="trade-customer"
              name="trade-customer"
              value={i18n.yes}
              checked={data.tradeCustomer}
              onClick={() => setData({ ...data, tradeCustomer: true })}
              onKeydown={radioKeyDown}
              aria-checked={props.checked}
              role="radio"
            />
            <RadioButton
              id="not-trade-customer"
              name="trade-customer"
              value={i18n.no}
              checked={!data.tradeCustomer}
              onClick={() => setData({ ...data, tradeCustomer: false })}
              onKeydown={radioKeyDown}
              aria-checked={props.checked}
              role="radio"
            />
          </div>
        </div>
      </fieldset>
    </div>
  )
}

export default BusinessInfo
